module.exports = __webpack_public_path__ + "05d36e6dc150f5babe03c08dacccbe96.pdf";